var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1190 856",
    width: 1190,
    height: 856,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img3-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m396.51 498.8v23.83h-54.01c0 7.16-5.8 12.96-12.96 12.96h-85.48c-8.01 0-14.51-6.5-14.51-14.51v-137.3c0-15.45 12.53-27.97 27.98-27.97h53.36c18.32 0 33.16 14.84 33.16 33.15v97.41z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m991.81 277.39l22.23 68.28c3.16 9.72 0.99 20.39-5.72 28.1l-30.37 34.88v29.53h-85.49v-139.11c0-21.89 17.75-39.63 39.64-39.63h33.62c11.58 0 21.95 7.14 26.09 17.95z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #20b723 } \n\t\t.s2 { fill: #fcb72d } \n\t\t.s3 { fill: #000000 } \n\t\t.s4 { fill: #493e3a } \n\t\t.s5 { fill: #ff5d7d } \n\t\t.s6 { fill: #4117ab } \n\t\t.s7 { fill: #f3efea } \n\t\t.s8 { fill: #3dc1ff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1190.6 855.6h-1190.6v-856.6h1190.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m977.6 438.2h-212.3v-310.9h212.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m246.7 389.9q-9.8 11.4-10.5 12.3c-0.7 0.9-13 23.9-20.5 48.9-7.6 24.9-20.9 24.9-20.4 58.6q0.5 33.6-6.8 56.3c6.3-17 4.8-47.2-0.9-56.3-5.7-9.1-12.7-36.4 4.1-74.8q16.8-38.4 58.5-49.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m155.5 494.7q1.3-88 70.2-122.7-16.6 31.7-19.2 54.2c-2.6 22.5-20.3 41.2-27.2 49.4q-6.8 8.2-23.8 19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m201.2 401.9q1.8-2.4 3-3.7-1.1 1.3-2.8 3.8c-1.8 2.5-4 6.1-6.3 10.7-4.8 9.2-9.7 22-13.8 35.1-2.1 6.6-3.9 13.2-5.5 19.5-1.5 5.5-2.7 10.7-3.8 15.3q-0.5 0.4-1 0.8c1-4.9 2.1-10.5 3.6-16.4 1.6-6.3 3.4-13 5.4-19.6 2.1-6.5 4.4-13 6.8-19.1 2.5-6 5.1-11.4 7.6-15.9 2.5-4.6 4.9-8.2 6.8-10.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m115.8 393.3q-4.8-12.1-9.7-21.3 68.9 34.7 70.2 122.7-17-10.9-23.8-19.1c-6.8-8.2-24.6-26.9-27.2-49.4-0.4-3.6-1.1-7.4-2.1-11.2 4.6-1.3 4.1-9.2-1.5-9.2q-0.6 0-1.2 0.2-0.8-2.5-1.7-5c2.1-2.5 1-7.3-3-7.7zm17 35.2c6 0 5.8-9.4-0.2-9.4-6 0-5.8 9.4 0.2 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m137.4 412.4c2.5 4.5 5.2 9.9 7.6 15.9 2.4 6.1 4.7 12.6 6.8 19.1 2 6.6 3.8 13.3 5.4 19.6 1.5 5.9 2.6 11.5 3.6 16.4q-0.5-0.4-1-0.8c-1-4.6-2.3-9.8-3.8-15.3-1.6-6.3-3.4-12.9-5.5-19.5-4-13.1-9-25.9-13.7-35.1-2.4-4.6-4.6-8.2-6.4-10.7q-1.7-2.5-2.8-3.8 1.2 1.3 3 3.7c1.9 2.3 4.3 5.9 6.8 10.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m184.3 679.2q-4.2-32.7-11.2-53.7-7-20.9-32.9-28.4 10.8-11.5 21.5-9c10.7 2.5 11.8 30.6 13.2 37.9q1.3 7.3 10.9 53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m84.5 608.5c3.5-5.7 7.5-10.1 11.5-13.4 0.9 0.9 2.1 1.4 3.4 1.4h0.3c2.6 0 4.7-2.3 4.6-4.8q0-1-0.4-1.9c6.9-3.6 12.7-4.2 14.6-3.5 3.6 1.4 16.5 2.6 26.5 0.8q10-1.7 16.7 1-18 8.4-21.5 9c-3.5 0.6-14.6 5.3-28.8 17.4-14.1 12.1-39.2 43.4-42.3 43.9-3 0.5 2.9-29.8 15.4-49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m127.3 587.8c1.4 0.1 1 0 2.7 0.1-16 4.6-49.4 19.6-60 66.4q5.9-48.2 57.3-66.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m190.6 679.2q9.5-45.9 10.9-53.2c1.4-7.3 2.5-35.4 13.2-37.9q10.7-2.5 21.4 9-25.9 7.5-32.8 28.4-7 21-11.3 53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m214.7 588.1q6.7-2.7 16.7-1c10 1.8 22.8 0.6 26.4-0.8 3.7-1.4 21.6 2.1 34.1 22.2 12.4 20.1 18.4 50.4 15.3 49.9-3.1-0.5-28.1-31.8-42.3-43.9-14.1-12.1-25.3-16.8-28.8-17.4q-3.4-0.6-21.4-9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m306.4 654.3c-10.7-46.8-44.1-61.8-60-66.4 1.6-0.1 1.2 0 2.7-0.1q51.4 18.3 57.3 66.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m102.6 474.9c7 4.6 14.3 6.8 35.2 10.9q20.9 4.1 28.2 20.2-0.9 6.4 1.6 17.3c2.5 10.9 15 45.9 18.2 52.4q3.1 6.5 2.7 103.5h-2.7q-2.3-39.8-1.6-48.2c0.7-8.4-5-18.6-5-31.4 0-12.7-1.8-41.1-27.1-55.2-13.6-7.6-21.2-14.7-29.5-22.3 1-2.8-0.5-6.5-4.3-6.5-0.9 0-1.6 0.2-2.3 0.6q-1.7-1.6-3.6-3.1c2.5-2.6 1.3-8.1-3.3-8.1-2 0-3.3 1-3.9 2.3-2.8-2.1-5.9-4.2-9.4-6.5q-26.4-17-50.9 1.1c12.9-34.5 50.7-31.5 57.7-27zm31.9 46.9c6 0 5.8-9.3-0.2-9.3-6 0-5.8 9.3 0.2 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m93.5 488.4c2.3 0.2 4.7 0.5 7.4 1q4 0.8 8.7 2.1c3 0.8 6.1 1.9 9.3 3.1 3.2 1.2 6.5 2.6 9.8 4.1 3.2 1.6 6.5 3.2 9.7 5 11.1 6.3 21.3 13.8 29.4 20.3q0 0.3 0.1 0.6c-8.1-6.5-18.6-14-29.9-20.3-3.1-1.8-6.4-3.5-9.6-5.1-3.2-1.5-6.5-2.9-9.6-4.2-3.2-1.2-6.4-2.3-9.4-3.1-3-0.9-5.8-1.6-8.5-2.1-2.7-0.5-5.2-0.9-7.4-1.1-2.2-0.3-4.1-0.3-5.7-0.4q-3.2 0-5 0 1.8-0.1 5-0.1c1.6 0.1 3.5 0 5.7 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s2",
    d: "m181.2 571.2c3.1-6.5 15.6-41.5 18.1-52.4q2.5-10.9 1.6-17.2 7.3-16.2 28.2-20.2c20.9-4.1 28.2-6.4 35.2-11 0.9-0.5 2.2-1 3.8-1.5-0.3 2.6 1.2 5.4 4.5 5.4 3.9 0 5.2-3.8 4.1-6.5 14.3-0.5 36.1 5.1 45.3 29.7q-24.5-18.2-50.9-1.2c-26.3 17.1-31.1 29.6-56.3 43.7-25.2 14.1-27 42.5-27 55.2 0 12.7-5.7 22.9-5 31.3q0.6 8.4-1.6 48.2h-2.8q-0.4-97 2.8-103.5zm51.4-80.9c6.1 0 5.9-9.4-0.1-9.4-6 0-5.9 9.4 0.1 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m279.2 483.7q3.1 0.1 5 0.2-1.9-0.1-5-0.1c-1.6 0.1-3.6 0.1-5.8 0.4-2.2 0.2-4.7 0.6-7.4 1.1-2.6 0.6-5.5 1.2-8.5 2.1-3 0.9-6.1 2-9.3 3.2-3.2 1.2-6.4 2.6-9.7 4.2-3.2 1.6-6.4 3.2-9.6 5-11.3 6.3-21.8 13.9-29.9 20.4q0.1-0.3 0.2-0.7c8-6.5 18.3-14 29.4-20.2 3.2-1.8 6.4-3.5 9.7-5.1 3.2-1.5 6.5-2.9 9.7-4.1 3.2-1.2 6.3-2.3 9.4-3.1 3-0.9 5.9-1.5 8.6-2 2.7-0.5 5.2-0.9 7.4-1 2.2-0.3 4.2-0.2 5.8-0.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m134.1 452.2l-10.3-2.5q4.4-1.9-28 1.4-32.4 3.2-57.2 16.7c20-26.2 54-30.8 57.9-29.2 3.8 1.5 7.6 5.2 19.5 5.1q11.9-0.1 22.3 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m187.3 679.2q-0.6-72.1-1.5-87.7c-0.9-15.7-6.9-24.1-16.4-43.2-9.5-19.1-13-56.6-20.7-62.3-7.7-5.6-21.1-22-26.6-28.4q-5.4-6.3-26.3-6.5c33.8-14.8 71.3 6.8 77.2 21.8 5.9 15 15.9 67.2 15.5 93.1q-0.5 25.9 0 113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m233.2 427.2c-15.3 38.2-35.7 42.6-34.4 79.2q1.4 36.6-10.3 59.6 11.3-42.4 0-71.3c-11.3-29 25.7-77 41-96.5q15.3-19.4 46.9-14.3c-17.3 1.7-27.8 5.1-43.2 43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m190.6 556.3l-0.6 122.9h-1.5l0.1-113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.2 604.9q-9.7 3.8-17.4 21.3v53h-1.6v-54.3q-6.8-22.5-4.9-33.9 5.8 0.9 23.9 13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m194.6 602.6q-3.2-42.3 9.9-65.6 13-23.2 58.6-33.6-10 12.9-18.9 33.6c-8.9 20.8-31.4 23.3-39.7 32.1q-8.4 8.8-6.5 33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m283.2 501.9q21.7 5 23 1.5-3.2 12.9-23.9 6-20.8-6.9-48.2 4.1c11.2-9 27.4-16.7 49.1-11.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m153.6 656.9c-3 35 21.4 59.6 51.2 71.1q-3.7 2.1-7.8 3.4h-22.4c-17.6-5.5-30.5-23.5-30.5-44.9 0-11.2 3.6-21.5 9.5-29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m153.5 656.9c2.7 1.2 16.2 2 32.6 2 15.4 0 28.4-0.8 32-1.8 5.8 8 9.3 18.3 9.3 29.4 0 18.1-9.2 33.8-22.6 41.5-29.9-11.5-54.3-36.1-51.3-71.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m215.7 700.5q0.2-94-39.4-109.5 16.4 1.9 31.7-4.9 30.7 55.9 7.7 114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m197.2 589.5c0.3 0.4 0.6 0.9 0.9 1.3 1.4 1.9 2.6 4.1 4 6.3 1.2 2.4 2.7 4.7 3.8 7.4q1 2 1.9 4 0.8 2 1.7 4.1c1.2 2.8 2 5.8 3 8.7 1 2.9 1.6 6 2.4 8.9 0.6 2.9 1.1 5.9 1.6 8.7 0.4 2.9 0.6 5.6 0.9 8.3 0.4 2.6 0.2 5.1 0.3 7.4 0.1 2.3 0.2 4.4 0 6.3q-0.1 2.8-0.2 4.8-0.2 2.7-0.3 4.2 0-1.5 0-4.2 0-2 0.1-4.8c0-1.9-0.2-4-0.3-6.3-0.2-2.3-0.2-4.7-0.6-7.3-0.3-2.6-0.6-5.4-1.1-8.2-0.5-2.8-1-5.7-1.7-8.6-0.8-2.9-1.4-5.9-2.4-8.8-0.9-2.9-1.7-5.8-2.9-8.6q-0.8-2.1-1.6-4.1-0.9-2.1-1.8-4c-1.2-2.6-2.5-5-3.7-7.4-1.3-2.3-2.4-4.4-3.7-6.4-0.3-0.5-0.7-1-1-1.5q0.4-0.1 0.7-0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m994.4 663.1c0.3-0.3-0.2 0.4 0 0 3.6-0.9 16-2.5 29.9-2.5 13 0 25 1.9 29.3 2.7 0.4 0.4-0.3-0.4 0 0-3.3 1-15.2 1.7-29.3 1.7-15 0-27.5-0.8-29.9-1.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m990.5 588.2c1.3 1 20.7 49.4 23.6 64.5q2.4 12.5 6.5 42.4l-3.5-0.2q-7.9-46.3-10.4-58.6-3.6-17.6-18.7-49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m977.1 581.9c-6.6-3.9-18.3-3.4-27.5-11.5-3.2-2.8-6.7-2-5.9-2.3 5.1-2 13.4-1 22.6-0.3 9.2 0.6 13.2 1 17.6 4.9 4.5 4 19.1 2.2 17.8 7q-1.3 4.8-11.2 8.5c-2.8-1.4-7.1-2.6-13.4-6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1057.8 621.1q-15 31.5-18.6 49.2-2.6 12.3-10.4 58.6l-3.5 0.2q4.1-29.9 6.5-42.4c2.8-15.1 22.3-63.6 23.5-64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1055.3 622.2q-9.8-3.8-11.1-8.6c-1.4-4.7 13.3-3 17.7-6.9 4.5-4 8.4-4.3 17.6-5 9.3-0.6 17.5-1.6 22.7 0.3 0.8 0.4-2.7-0.5-6 2.4-9.1 8-20.8 7.6-27.4 11.5-6.3 3.7-10.7 4.8-13.5 6.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1034.4 687.3c-1.1-11.5-6.8-48.1-5.3-80.8 0.8-17.2 11.6-74.8 17.4-87.6 3.4-7.4 6.3-13.1 8.2-16.1 0.4-1.1 5.5-4 2.4 1.3-3.1 5.3-15.5 24.2-23.8 95-4 34.2 7.6 111.6 8.3 113.3q0.8 1.6-3.6 3c-2.4-18.8-2.7-17.8-3.6-28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1050.3 467.3c4.1-16.7 37.8-30.5 49.5-31.9 11.5-1.4 21.2-2.2 29-4.4 7.8-2.1 28.3-12 21.9 1.2-6.4 13.3-28.3 18.6-49.5 30.7q-21.2 12-42.4 39.9c-9.9-6.7-12.1-21.1-8.5-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1058.8 502.8l-2.9 3.5q-7 3.9-12.1-5.4-5-9.3 5.5-28.9-2 23.4 9.5 30.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1043.3 441.4l-8.1 13.5q-17.8-5.7-17.8-13.5c0-7.7-2.2-5.3-5.1-6.9-2.8-1.6-2.4-6.9 0-11 2.5-4.1-1.9-4.8-4-6.9-2-2-8.5-16.8 17.3-24.9 10.9-3.5 10.4-0.8 13.6 0 3.3 0.8-10.2 26.5 4.1 49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1045.4 441.4q-11.5-2.4-9.8-9.4c1.6-6.9 2-12.6-2.5-17.1-4.5-4.5 2.9-28.9 12.3-38.3 9.3-9.4 33-21.2 41.1-27.7 8.2-6.6 18-8.3 28.6-13.4 10.6-5 31.8-21.7 32.2-31.1 0.4-9.4 6.9 15-9 31.1-15.9 16.2-56.2 48-62.4 58.2-6.1 10.2-26.9 35.9-30.5 47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1046.4 438.7q-14.9 26-21.7 118.9-2 27.3 5.6 106.6l-4.4-0.1q-6.5-80.4-4.1-107.9c2.5-27.5 11.4-95.6 13.4-101.3q3.4-10.4 11.2-16.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m989.4 509.4c2.3-0.9 1.6-2.9 10.2-1.5 20.4 3.1 17.2 15 15.9 16.7-1.3 1.8-4.5 2.9-2.2 5.6 2.3 2.8 3.3 6.8 1.3 8.3-2 1.6-3.9 0-3 5.8q0.9 5.8-11.8 12.2l-7.7-9.2c8-19.1-5.1-36.9-2.7-37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m962 515.2c-5.8-6.9-39.8-26.1-53.7-36.5-13.8-10.3-11.7-29.3-10.3-22.3 1.3 7 19.2 17.1 27.8 19.6 8.6 2.6 16.1 2.8 23 6.8 6.9 3.9 26.1 10 34.2 16 8.2 6 16.5 23.5 13.7 27.4-2.9 3.9-1.9 8.2 0.1 13.2q2.1 5-6.2 8.2c-4.2-8.5-22.8-25.4-28.6-32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m999.8 556.5c2.1 4.1 16.8 54.2 21.8 74.7q5 20.4 9.5 81.6l-3.3 0.5q-3.5-60.5-8.2-80.7-15.9-69.2-30.1-86.9 6.5 3.4 10.3 10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m985.3 481.3q14.1 27.6 21.8 55.8 7.3 26.8 22.5 158.5-5.1 7.9-4.8 0.5c0.3-7.3-11.6-107.3-17.5-141.7q-5.9-34.4-25.2-72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m933.6 406.2q30.6 11 34.2 16c3.5 5 14 18.4 16.2 24.6 2.2 6.1 9.9 5.6 12.4 7.2 2.4 1.5 3.9 15.4 6.3 20.4 2.3 5.1 4 9.4 3.2 13.4-0.9 3.9-8.2 8.9-11 6.7-2.8-2.2-31.8-43.9-43.7-49.1-11.9-5.3-23-5.9-27-15.5-2.6-6.1 5.3-20.1 9.4-23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m933.8 407.8q23.9 32.7 35.4 46.4 11.6 13.7 23.2 32-33.6-44.1-36.1-47c-2.6-2.9-20-28.1-22.5-31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m960.6 457.6c-12.2-12.6-32.1-20.3-28.2-19.5 8.5 2 25 3.7 24.7 8.6-0.4 4.9 24.7 15.2 26.6 17.8 1 1.3 0.9 8.2 4.3 11 3.3 2.9 9.8 13.6 7.8 17.7q-1.9 4.1-7.7 3c-5.8-19.4-18.4-29.1-27.5-38.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1056.4 554.4c-7.7 19.8-32.5 124.6-32.7 131.4q-0.1 6.7-7.2 3 32.7-129.5 38.8-137.9c11.3-15.5 4.2-4.5 1.1 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1074.1 562q-12.2 2.2-17.1-7.2c-5-9.3-4.6-12.5-3.5-14.9q1.1-2.5-3.9-7.3-1.2-9.2 4.9-16.2c6.2-7 8-5.6 11.7-9.1 3.7-3.6 8.8-17.4 21.2-19.6q2.3-0.4 4.5 0.8 4.4-4.8 15.3-7.2c11-2.4 12.1-4.8 15.8-7.8 3.7-3.1 8.8-3.5 10.6-7.6 1.8-4.2 2.7 15.4-1.4 21.3-4 5.9-9.3 11.9-10.6 17.6-1.3 6.4-4.4 13.2-7.9 16.1-0.9 0.7-14.2 7.8-18.4 16.4-4.1 8.3-7.8 19.2-21.2 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1129.4 475.6q-70 58.7-74.1 76l1.7 3.2q3.3-10.1 11.6-19.1c20.2-21.9 49-48.1 60.8-60.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m995.2 663.4c3.8 0.9 15.3 1.6 28.8 1.6 14.2 0 26-0.7 29.4-1.7 5.3 7.4-2.5 19.3-2.5 29.5 0 16.6 2.5 28.4-9.8 35.5q0.1 0 0.1 0-3 1.7-6.3 2.8c-23.1-12.6-33.9-41.4-39.7-67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m994.7 663.3q0.2 0.1 0.5 0.1c5.8 26.3 16.6 55.1 39.7 67.7q-0.4 0.2-0.9 0.3h-10-9.9q-3.8-1.2-7.2-3.1c-12.3-7.1-9.7-18.9-9.7-35.5 0-10.2-7.8-22.1-2.5-29.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m944.7 195.5l21.7 15.3-10.9 18.7v36.5l-26.1 6.2v-31.7l-12.3-5.9c-6-3-9-9.8-7.1-16.2l6.7-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m900.3 330.3l-30.5 25.6c-7 5.8-18 0.2-16.7-8.8q0.1-0.5 0.2-1l34.9-108.9-2.5-9.4c-0.9-3.8 1.5-7.7 5.4-8.5 3.2-0.6 6.5 1.1 7.8 4.3l3.7 9.3 5.8-1.5c1.1-0.3 2.1 1 1.5 2l-6 5.4-11.4 37.5 25.6-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m894 274.7l24.1-12.7-17.8 68.3-30.5 25.6c-7 5.8-18 0.2-16.7-8.8q0.1-0.5 0.2-1l28.5-93.7 18.5 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m939.1 438.2v286.9l-49.8 11.5q1.3-2.3 2.7-4.5c4.4-6.4 10.4-11.4 17.4-14.8l5.7-2.7c7.7-3.8 10.6-13.3 6.2-20.8l-8.6-14.8-5.5 3.2-58-114.2 43.3-129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m939.1 663.2v61.9l-49.8 11.5q1.3-2.3 2.7-4.5c4.4-6.4 10.4-11.4 17.4-14.8l5.7-2.7c7.7-3.8 10.6-13.3 6.2-20.8l-8.6-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m939.1 725.1l-49.8 11.5q1.3-2.3 2.7-4.5c4.4-6.4 10.4-11.4 17.4-14.8l5.7-2.7c3.4-1.7 5.9-4.6 7.2-7.9l3.2 0.5c4.8 0.9 9.8-0.3 13.6-3.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m767.6 686l13.6 20-57.8 34c0-6 2.3-11.7 6.5-16 1.6-1.7 3-3.7 4-5.9l13.5-27.8-11.4-101.3h38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m767.6 686l13.6 20-57.8 34c0-6 2.3-11.7 6.5-16 1.6-1.7 3-3.7 4-5.9l13.5-27.8-3.5-30.6h25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m781.2 706l-57.8 34c0-6 2.3-11.7 6.5-16 1.6-1.7 3-3.7 4-5.9l13.5-27.8q5 6.2 6.2 6.2 1.2 0 14-10.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m831.1 325.3v42.4h-37.3v-42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m809.4 335.1c-5.1 2.7-11.5 2-15.6 1.2v-7.1c8.7 1 21.2 3 15.6 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m809.7 337.7l-11.8-2.8c-12.8-2.9-21-15.9-18-28.7l0.4-1.8c3-12.9 15.9-21 28.8-18l11.8 2.7c12.9 2.9 21 15.9 18 28.7l-0.4 1.9c-3 12.8-15.9 20.9-28.8 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m863.7 395.1v139.1h-105.7v-34.2c-2 8.1-11.7 11.5-18.3 6.4l-54-40.6h-13.1c-3.2 0-6-2.2-6.8-5.4-0.8-3.5 1.3-7.1 4.8-8.1l8.1-2.5v-4.2c0-1.6 2-2.4 3.1-1.3l4.3 4.4 44.5 20.6 12-60.3c5-25.5 27.4-43.9 53.4-43.9h47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m717.1 463.1l-9.3 19.3-22.1-16.6h-13.1c-3.2 0-6-2.2-6.8-5.4-0.8-3.5 1.3-7.1 4.8-8.1l8.1-2.5v-4.2c0-1.6 2-2.4 3.1-1.3l4.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m342.5 521.6h56.8c30.6 0 53.1 28.8 45.8 58.5l-23.6 95.1h-29.3v-86.2h-133.5c-11 0-19.8-8.9-19.8-19.9v-33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m394.1 498.2l10.7 2.5q14.8 0 15.9 0 1.2 0-5.2 4.3l8.5 11.3c2.3 3.1 2.1 7.4-0.5 10.2-2.7 3.1-7.4 3.6-10.7 1.1l-11.8-8.6h-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m735.6 438.2h-439.8v-310.9h439.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m581.6 274.1h-63.3v-62.7c0-20 16.1-36.1 36.1-36.1 15 0 27.2 12.2 27.2 27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m564.3 260.1h-26.9v-37.3h26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m537.4 222.8h26.9v19.8c-1.9 0.7-4 1-6.2 1-11.4 0-20.7-9.4-20.7-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m583.7 259.4c11.8 0 21.9 8.6 23.8 20.2l10.1 60.7 61.1 27.9h13.4c1.7 0 2.7 1.8 1.8 3.2-0.6 1.1-0.2 2.5 1 3l8.6 3.9c3.1 1.4 4.8 4.8 4.1 8.1-0.8 3.9-4.5 6.4-8.4 5.7l-83-14.6c-8.8-1.5-15.7-8.4-17.3-17.2l-18.3-100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m526.1 259.4l-18.3 100.9c-1.6 8.8-8.5 15.7-17.3 17.2l-83 14.6c-3.9 0.7-7.7-1.8-8.5-5.7-0.6-3.3 1.1-6.7 4.2-8.1l8.6-3.9c1.1-0.5 1.6-1.9 0.9-3-0.8-1.4 0.2-3.2 1.8-3.2h13.4l61.2-27.9 10.1-60.7c1.9-11.6 12-20.2 23.8-20.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s5",
    x: 533.3,
    y: 192.2,
    width: 41.6,
    height: 49.7,
    rx: 20.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m527.1 211.1l7.7-17.6 23.5-6.2 17.8 11v8.7q-15.2-0.4-17.3-12.4c-1.6 6.4-6.5 11.4-12.8 13.2l-16.1 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m537.3 222.1c-2.4 1.9-5.9 1.5-7.8-0.9l-1.1-1.4c-1.8-2.4-1.4-5.9 1-7.8 2.4-1.9 5.9-1.4 7.8 1l1 1.3c1.9 2.4 1.5 5.9-0.9 7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m505.9 280.1c-2.2-10.7 5.9-20.7 16.8-20.7h57.9c8.4 0 15.2 6.9 15.2 15.3v24.1l12.3 19.4c2.6 4.1 2.8 9.4 0.3 13.5q-5.3 8.6-17.2 11.2l22.8 184.4h-122.8q-13-129.5 30.9-145.6l-12.3-82.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m551.4 527.3v186.8h-9.2v-4.9l-28.2 7.8q-0.5 0.2-1.1 0.2c-3.3 0-5-4.1-2.7-6.5l16.8-17.1c3.2-3.2 4.7-7.8 4-12.4l-24-153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m534.3 698.9l17.1-8v23.2h-9.2v-4.9l-28.2 7.8c-1 0.3-2 0.2-2.9-0.3-2.4-1.3-2.6-4.3-0.7-6.2l16.3-16.5c0 3.9 4.1 6.5 7.6 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m602.8 527.3l-24 153.9c-0.8 4.6 0.7 9.2 3.9 12.4l16.8 17.1c2.4 2.4 0.7 6.5-2.7 6.5q-0.5 0-1-0.2l-28.2-7.8v4.9h-9.2v-186.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m583.1 694l16.3 16.5c1.9 1.9 1.6 4.9-0.7 6.2-0.9 0.5-2 0.6-2.9 0.3l-28.2-7.8v4.9h-9.2v-23.2l17 8c3.6 1.6 7.7-1 7.7-4.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m567.4 259.4l-6.5 35.5-26.2-35.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m304.8 339l-15.5 2.6c-9.1 1.5-17.7-4.7-19.2-13.8l-3.1-18.3c-2.1-13 6.8-25.4 19.8-27.6l8.3-1.4c13.1-2.1 25.5 6.8 27.6 19.8l1.9 11.1c2.1 13-6.8 25.5-19.8 27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m396.5 498.8v23.8h-54c0 7.2-5.8 13-13 13h-85.4c-8.1 0-14.5-6.5-14.5-14.5v-137.3c0-15.5 12.5-28 27.9-28h53.4c18.3 0 33.2 14.9 33.2 33.2v97.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 323.9,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 323.9,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 342.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 342.2,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 360.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 360.4,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 378.7,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 378.7,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 397,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 397,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 415.2,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 415.2,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 433.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 433.5,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 451.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 451.8,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 470,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 470,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 488.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 488.3,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 506.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 506.5,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 524.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 524.8,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 543.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 543.1,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 196.6,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 217.2,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 237.7,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 258.2,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 278.8,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 299.3,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 319.8,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 340.4,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 360.9,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 381.4,
    cy: 561.3,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s7",
    cx: 401.9,
    cy: 561.3,
    r: 4.6
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m272.3 355.3l4.9-25.8h27.3l-1.8 25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m327.3 520.8c-17-0.8-29.8-15.9-27.8-32.9l9.8-83.4v83.9c0 18.4 14.9 33.2 33.2 33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m438.8 727.4c4.8 4.8 6.8 11.8 5.2 18.5l-57.5-31.8 10-18.3v-20.6h22.9l-4.1 20.2 1.6 2.8c5.8 10.5 13 20.1 21.4 28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m386.5 714.1l10-18.3 12.4 4.7 6.4-5.1 1.6 2.8c5.8 10.5 13 20.1 21.4 28.6l0.5 0.6c4.8 4.8 6.8 11.8 5.2 18.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m384.9 589l-33.4 62-28.3-7.2 14-54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m355.4 705.8c3.4 5.9 3.6 13.2 0.5 19.3l-47.8-45.1 14.1-15.2 5.1-20 22.2 5.7-9 18.5 0.9 3.2c3 11.5 7.6 22.6 13.6 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m308.1 680l14.1-15.2 10.9 7.6 7.4-3.4 0.9 3.2c3 11.5 7.6 22.6 13.6 33l0.4 0.6c3.4 5.9 3.6 13.2 0.5 19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m326.3 648.9l1-4.1 22.2 5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m356.6 608.4h-104.2c-5.3 0-9.7-4.4-9.7-9.7 0-5.4 4.4-9.7 9.7-9.7h104.2c5.3 0 9.7 4.3 9.7 9.7 0 5.3-4.4 9.7-9.7 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m268.8 752.9h-12.4l28.6-144.5h12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m354.9 752.9h-12.5l-28.6-144.5h12.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m851 608.4h-104.2c-5.3 0-9.7-4.4-9.7-9.7 0-5.4 4.4-9.7 9.7-9.7h104.2c5.3 0 9.7 4.3 9.7 9.7 0 5.3-4.4 9.7-9.7 9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m763.2 752.9h-12.5l28.7-144.5h12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m849.2 752.9h-12.4l-28.7-144.5h12.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m806.8 319.5c-7.5-3.8-11.2-12.5-8.8-20.5l-15.5-3.6c2.8-7.8 11.2-12.6 19.6-10.7l25.8 6c9 2.1 14.7 11.1 12.6 20.1l-3.6 15.9c-0.6 2.4-1.7 4.6-3.1 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m839.3 299.9c4.8 9.1 7.1 19.4 6.6 29.8l-0.1 3.4c-0.8 15.3 3.4 30.6 12 43.3l4 6c3.6 5.4 5 11.9 3.8 18.3-1.7 9-8.5 16.3-17.4 18.7l-8.7 2.4c-9.4 2.6-19.5 0.1-26.7-6.6-8.2-7.6-12.4-18.6-11.5-29.8l5.5-65.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m862.6 565.4c-0.5 13.6-11.6 24.3-25.1 24.3h-119.9l-7.8 106.1 13.6 20-57.7 34c0-6 2.3-11.7 6.4-16 1.7-1.8 3-3.7 4.1-5.9l13.4-27.8-15.3-136.1c-1.8-15.9 10.7-29.8 26.7-29.8h162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m863.7 534.2l-1.1 31.2c-0.5 13.6-11.6 24.3-25.1 24.3h-119.9l-5.1 70h-27.4l-10.8-95.7c-1.8-15.9 10.7-29.8 26.7-29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m723.4 715.8l-57.7 34c0-6 2.3-11.7 6.4-16 1.7-1.8 3-3.7 4.1-5.9l13.4-27.8q5.1 6.2 6.2 6.2 1.2 0 14-10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m963.3 198.1l10 19.8-9.4 7.2c-1.6 1.2-2.8 2.8-3.7 4.6l-4.5 10-4.6-4.3c-2-1.9-3.2-4.5-3.2-7.3v-9.4l-8.5 4-0.6-1.3c-2.6-5.4-1.9-11.8 1.9-16.5l-24.2-9c-2.3-0.9-4.3-2.7-5.4-4.9l-0.5-1.1c-2.1-4.3-1-9.4 2.8-12.3 3.5-2.8 8.6-2.8 12.2 0l0.4 0.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s6",
    cx: 933,
    cy: 182.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s6",
    cx: 946.8,
    cy: 188.1,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s6",
    cx: 959.4,
    cy: 197,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s6",
    cx: 963.3,
    cy: 209.9,
    r: 12.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m991.8 277.4l22.2 68.3c3.2 9.7 1 20.4-5.7 28.1l-30.4 34.9v29.5h-85.4v-139.1c0-21.9 17.7-39.7 39.6-39.7h33.6c11.6 0 22 7.2 26.1 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m456.4 199.9h-114.1c-4.3 0-7.8-3.6-7.8-7.9 0-4.3 3.5-7.8 7.8-7.8h114.1c4.3 0 7.9 3.5 7.9 7.8 0 4.3-3.6 7.9-7.9 7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m484.2 230.7h-145.8c-2.2 0-3.9-1.8-3.9-4 0-2.1 1.7-3.9 3.9-3.9h145.8c2.2 0 4 1.8 4 3.9 0 2.2-1.8 4-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m379.5 250.9c0 2.1-1.7 3.9-3.9 3.9h-37.2c-2.2 0-3.9-1.8-3.9-3.9 0-2.2 1.7-4 3.9-4h37.2c2.2 0 3.9 1.8 3.9 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m402.1 246.9h82.1c2.2 0 4 1.8 4 4 0 2.1-1.8 3.9-4 3.9h-82.1c-2.2 0-3.9-1.8-3.9-3.9 0-2.2 1.7-4 3.9-4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s7",
    x: 334.5,
    y: 271,
    width: 35.7,
    height: 7.8,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s7",
    x: 384.2,
    y: 271,
    width: 104,
    height: 7.8,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s7",
    x: 334.5,
    y: 295.2,
    width: 73.1,
    height: 7.8,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s7",
    x: 419.2,
    y: 295.2,
    width: 45.1,
    height: 7.8,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s7",
    x: 334.5,
    y: 319.3,
    width: 125.1,
    height: 7.8,
    rx: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m392.8 347.3c0 2.2-1.8 3.9-4 3.9h-50.4c-2.2 0-3.9-1.7-3.9-3.9 0-2.2 1.7-3.9 3.9-3.9h50.4c2.2 0 4 1.7 4 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m665.7 224.7h-40.6v-40.5h40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m695.8 275h-40.6v-40.5h40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m580.6 341.5q4.6 2.6 10.6 1.4l0.8 6.8q-7.9-2-11.4-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m307.7 299.7c0 8.3-1.8 16.4-5.2 24l-3.4 7.5c-2.7 5.9-8.2 10.1-14.6 11.2-6.4 1-12.6-3.4-13.6-9.8l-5-30c-1.5-9.2 4.8-18 14.1-19.6l22-3.6c8.2-1.4 16 3.5 18.8 11q-4.5 6.9-13.1 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m305.9 326.1c-3.2 1.8-7.3 0.7-9.1-2.4l-1-1.8c-1.9-3.2-0.8-7.3 2.4-9.1 3.2-1.9 7.3-0.8 9.1 2.4l1.1 1.8c1.8 3.2 0.7 7.3-2.5 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m238.9 535.6h95.6l-95.6 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m396.5 675.2h22.9l-22.9 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m805.5 325.4c-2.8-1.9-3.6-5.7-1.7-8.5l1-1.6c1.9-2.8 5.7-3.5 8.5-1.7 2.8 1.9 3.6 5.7 1.7 8.5l-1 1.6c-1.9 2.8-5.7 3.6-8.5 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m758 500l19.2-69.3-19.2 94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m977.9 438.2l-5.4 252.7h-10.9v45.7h-60.6q1-1.6 2.1-3c4.2-5.4 10.7-8.6 17.5-9.2 10.5-0.9 18.5-9.6 18.5-20.1v-13.4h-4.2l-27.7-252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m977.9 438.2l-1.8 11.4-83.6-11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m961.6 691v45.6h-60.6q1-1.6 2.1-3c4.2-5.4 10.7-8.6 17.5-9.2 10.5-0.9 18.5-9.6 18.5-20.1v-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m961.6 736.6h-60.6q0.9-1.5 2-3c4.3-5.4 10.8-8.6 17.7-9.2 6.2-0.6 11.5-3.9 14.8-8.7 5.7 6.2 14.2 9 22.5 7.4l3.6-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m934.9 690.9h-6.6l-21.1-252.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m915.3 683.5l-2.6-4.5 18.6-11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m977.9 408.7l-35.1 40.9-9.2-9.1 49.8-90.8-16.1-50.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m977.9 408.7v8.2l-35.1 32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m943 230.6c-2.7-1.8-3.5-5.6-1.7-8.3l1-1.5c1.9-2.8 5.6-3.5 8.3-1.7 2.7 1.8 3.5 5.5 1.7 8.3l-1 1.5c-1.9 2.7-5.6 3.5-8.3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m929.4 244.8v-4.3l12 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m968.3 539.3h-30.4v-48.5h30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m922 596.9l-14.8-26.4 10.9-27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m933.6 440.5l12.9 12.6-3.7 2.3-14.6-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m897.1 273.4l-13.7 40.4 10.6-39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m507 527.3h44.4l-43.3 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m558.4 527.3h44.4l-44.4 6.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: <Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1007.4 292.9c-7.4 0-11.1-4.2-14.2-7.5-2.8-3.2-4.6-5-8.4-5-3.7 0-5.5 1.8-8.4 5-3 3.3-6.8 7.5-14.2 7.5-7.4 0-11.1-4.2-14.2-7.5-2.8-3.2-4.6-5-8.4-5-3.7 0-5.5 1.8-8.4 5-3 3.3-6.8 7.5-14.2 7.5-7.3 0-11.1-4.2-14.1-7.5-2.9-3.2-4.7-5-8.5-5-3.7 0-5.5 1.8-8.4 5-3 3.3-6.8 7.5-14.2 7.5-7.3 0-11.1-4.2-14.1-7.5-2.9-3.2-4.7-5-8.5-5v-7.7c7.4 0 11.2 4.1 14.2 7.4 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.5-5 3-3.3 6.8-7.4 14.1-7.4 7.4 0 11.2 4.1 14.2 7.4 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.4 14.2-7.4 7.4 0 11.2 4.1 14.2 7.4 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.4 14.2-7.4 7.4 0 11.1 4.1 14.2 7.4 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.4 14.2-7.4v7.7c-3.7 0-5.5 1.8-8.4 5-3 3.3-6.8 7.5-14.2 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1007.4 318.8c-7.4 0-11.1-4.1-14.2-7.5-2.8-3.1-4.6-4.9-8.4-4.9-3.7 0-5.5 1.8-8.4 4.9-3 3.4-6.8 7.5-14.2 7.5-7.4 0-11.1-4.1-14.2-7.5-2.8-3.1-4.6-4.9-8.4-4.9-3.7 0-5.5 1.8-8.4 4.9-3 3.4-6.8 7.5-14.2 7.5-7.3 0-11.1-4.1-14.1-7.5-2.9-3.1-4.7-4.9-8.5-4.9-3.7 0-5.5 1.8-8.4 4.9-3 3.4-6.8 7.5-14.2 7.5-7.3 0-11.1-4.1-14.1-7.5-2.9-3.1-4.7-4.9-8.5-4.9v-7.8c7.4 0 11.2 4.2 14.2 7.5 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.5-5 3-3.3 6.8-7.5 14.1-7.5 7.4 0 11.2 4.2 14.2 7.5 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.5 14.2-7.5 7.4 0 11.2 4.2 14.2 7.5 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.5 14.2-7.5 7.4 0 11.1 4.2 14.2 7.5 2.9 3.2 4.7 5 8.4 5 3.8 0 5.6-1.8 8.4-5 3.1-3.3 6.8-7.5 14.2-7.5v7.8c-3.7 0-5.5 1.8-8.4 4.9-3 3.4-6.8 7.5-14.2 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1007.4 344.8c-7.4 0-11.1-4.2-14.2-7.5-2.8-3.2-4.6-4.9-8.4-4.9-3.7 0-5.5 1.7-8.4 4.9-3 3.3-6.8 7.5-14.2 7.5-7.4 0-11.1-4.2-14.2-7.5-2.8-3.2-4.6-4.9-8.4-4.9-3.7 0-5.5 1.7-8.4 4.9-3 3.3-6.8 7.5-14.2 7.5-7.3 0-11.1-4.2-14.1-7.5-2.9-3.2-4.7-4.9-8.5-4.9-3.7 0-5.5 1.7-8.4 4.9-3 3.3-6.8 7.5-14.2 7.5-7.3 0-11.1-4.2-14.1-7.5-2.9-3.2-4.7-4.9-8.5-4.9v-7.8c7.4 0 11.2 4.1 14.2 7.5 2.9 3.1 4.7 4.9 8.4 4.9 3.8 0 5.6-1.8 8.5-4.9 3-3.4 6.8-7.5 14.1-7.5 7.4 0 11.2 4.1 14.2 7.5 2.9 3.1 4.7 4.9 8.4 4.9 3.8 0 5.6-1.8 8.4-4.9 3.1-3.4 6.8-7.5 14.2-7.5 7.4 0 11.2 4.1 14.2 7.5 2.9 3.1 4.7 4.9 8.4 4.9 3.8 0 5.6-1.8 8.4-4.9 3.1-3.4 6.8-7.5 14.2-7.5 7.4 0 11.1 4.1 14.2 7.5 2.9 3.1 4.7 4.9 8.4 4.9 3.8 0 5.6-1.8 8.4-4.9 3.1-3.4 6.8-7.5 14.2-7.5v7.8c-3.7 0-5.5 1.7-8.4 4.9-3 3.3-6.8 7.5-14.2 7.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m977.9 350.9l-10.6-51.8 16.1 50.6-49.8 90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m392.2 589h16.7l-16.7 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m548.7 225c-4.4 0-8-3.5-8-7.9 0-4.4 3.6-8 8-8 4.3 0 7.9 3.6 7.9 8 0 4.4-3.6 7.9-7.9 7.9zm0-14.3c-3.6 0-6.5 2.8-6.5 6.4 0 3.5 2.9 6.4 6.5 6.4 3.5 0 6.4-2.9 6.4-6.4 0-3.6-2.9-6.4-6.4-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s3",
    d: "m568.9 225c-4.4 0-8-3.5-8-7.9 0-4.4 3.6-8 8-8 4.4 0 8 3.6 8 8 0 4.4-3.6 7.9-8 7.9zm0-14.3c-3.5 0-6.4 2.8-6.4 6.4 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-3.6-2.9-6.4-6.4-6.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.c7ba5cf2e84b71535a8ac6bc789076c3.svg";
export { ForwardRef as ReactComponent };